import React from 'react'
import { Route, Routes } from 'react-router'
import SystemMasterListPage from '../app/master/pages/SystemMasterListPage'
// User 
import UserListPage from '../app/admin/user/pages/UserListPage'
import UserDetailsPage from '../app/admin/user/pages/UserDetailsPage'
import UserRoleListPage from '../app/admin/user/pages/UserRoleListPage'
//Business
import BusinessDetails from '../app/admin/business/pages/BusinessDetails'
//CMS
import ManageKioskFaqPage from '../app/admin/cms/pages/ManageKioskFaqPage'
import AdminLandingPage from '../app/admin/dashboard/pages/AdminLandingPage'
import TaskDashnoardPage from '../app/admin/task/pages/TaskDashnoardPage'
import TaskArchivedList from '../app/admin/task/pages/TaskArchivedList'
import DeviceDashboardPage from '../app/admin/device/pages/DeviceDashboardPage'
import BotPage from '../app/admin/bot/pages/BotPage'
import NotesDashboardPage from '../app/admin/notes/pages/NotesDashboardPage'
import TaskCalendarPage from '../app/admin/task/pages/TaskCalendarPage'
import AssistentPage from '../app/admin/assistant/pages/AssistentPage'






function AdminRoutes() {
  return (
    <>
      <Routes>
        {/* Business Details */}
        <Route path="/" element={<AdminLandingPage/>}></Route>
        <Route path="/business/details" element={<BusinessDetails />}></Route>
        {/* User */}
        <Route path="/user/list" element={<UserListPage /> }></Route>
        <Route path="/user/details/:id" element={<UserDetailsPage /> }></Route>
        <Route path="/user/role" element={<UserRoleListPage /> }></Route>
        {/* CMS */}
        <Route path="/cms/kiosk-faq" element={<ManageKioskFaqPage /> }></Route>
        {/* Masters */}
        <Route path="/master/list" element={ <SystemMasterListPage /> } />

        {/* Task */}
        <Route path="/task/dashboard" element={<TaskDashnoardPage /> }></Route>

        <Route path="/task/calendar" element={<TaskCalendarPage /> }></Route>
      
        <Route path="/task/archived" element={<TaskArchivedList /> }></Route>

        {/* Device */}
        <Route path="/device/dashboard" element={<DeviceDashboardPage /> }></Route>


        {/* Device */}
        <Route path="/notes/dashboard" element={<NotesDashboardPage /> }></Route>

         {/* Bot */}
         <Route path="/megamind/bot" element={<BotPage /> }></Route>


         {/* Bot */}
         <Route path="/megamind/assistant" element={<AssistentPage /> }></Route>
      </Routes>
    </>
  )
}

export default AdminRoutes